export { default } from '@material-ui/core/Table';
